const GroupsView = () => {
  return <div>GroupsView</div>;
};

export default GroupsView;
